import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PilotCallout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: '#e3f2fd',
        py: { xs: 6, md: 10 },
        px: { xs: 2, sm: 4 },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={5}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 4,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            gutterBottom
            sx={{ mb: 3 }}
          >
            {t('pilot_callout.title', 'Join our Pilot Program')}
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 4 }}
          >
            {t('pilot_callout.description', 'Be among the first to experience our service and give feedback.')}
          </Typography>

          <Button
            onClick={() => navigate('/signup')}
            variant="contained"
            size="large"
            sx={{
              minWidth: '200px',
              px: 5,
              py: 1.5,
              fontWeight: 'bold',
              fontSize: '1rem',
              textTransform: 'none',
              backgroundColor: '#1976d2',
              color: '#fff',
              borderRadius: 2,
              '&:hover': {
                backgroundColor: '#115293',
              },
            }}
          >
            {t('pilot_callout.cta', 'Get Started')}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default PilotCallout;
